import { render, staticRenderFns } from "./customerStatementsList.vue?vue&type=template&id=3b483d42&scoped=true&"
import script from "./customerStatementsList.vue?vue&type=script&lang=js&"
export * from "./customerStatementsList.vue?vue&type=script&lang=js&"
import style0 from "./customerStatementsList.vue?vue&type=style&index=0&id=3b483d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b483d42",
  null
  
)

export default component.exports